/**
 * Si el valor seleccionado no está entre las alternativas (p. ej. prellenado desde incidente
 * con un literal fuera del enum), agrega una opción { id, label } usando el valor tal cual,
 * sin traducción, para que el selector pueda mostrarlo.
 */
export function mergeLiteralIntoAlternativas(
  alternativas: any[] | undefined,
  selectedValue: any,
  isAlternativeTree: boolean | undefined,
): any[] {
  const raw = Array.isArray(alternativas) ? alternativas.filter(Boolean) : [];
  if (raw.length === 0) return raw;
  if (isAlternativeTree) return raw;
  if (selectedValue === null || selectedValue === undefined || selectedValue === '') return raw;

  const v =
    typeof selectedValue === 'object' &&
    selectedValue !== null &&
    selectedValue.id !== undefined &&
    selectedValue.id !== null
      ? String(selectedValue.id)
      : String(selectedValue);

  if (v === 'others') return raw;

  const existing = new Set(
    raw.map((alt) => String(alt?.id ?? alt?.value ?? '')).filter(Boolean),
  );
  if (existing.has(v)) return raw;

  return [...raw, {id: v, label: v}];
}
